// extracted by mini-css-extract-plugin
module.exports = {"btn":"TutorialLink_btn__f06wj","btnIcon":"TutorialLink_btnIcon__L1ezc","tutorial":"TutorialLink_tutorial__ZrRYe","video":"TutorialLink_video__Iryxp"};